import {AI_DESIGN_ASSIST_EXPERIMENT_NAMES} from './constants/ai-design-assist';
import {LIFECYCLE_EXPERIMENT_NAMES} from './constants/lifecycle';
import {LOCALIZATION_FLAG_NAMES} from './constants/localization';
import {
  SP_SUCCESS_EXPERIMENT_NAMES,
  SP_SUCCESS_EXPERIMENT_LAYERS,
} from './constants/sp-success';
import {USER_EXPANSION_EXPERIMENT_NAMES} from './constants/user-expansion';

export const CURRENT_EXPERIMENTS = {
  ...AI_DESIGN_ASSIST_EXPERIMENT_NAMES,
  ...LIFECYCLE_EXPERIMENT_NAMES,
  AUTO_SET_PRIMARY_LOCALE: LOCALIZATION_FLAG_NAMES.AUTO_SET_PRIMARY_LOCALE,
  ...SP_SUCCESS_EXPERIMENT_NAMES,
  ...USER_EXPANSION_EXPERIMENT_NAMES,
} as const;

export const CURRENT_LAYERS = {
  ...SP_SUCCESS_EXPERIMENT_LAYERS,
} as const;

export type ExperimentName =
  | (typeof CURRENT_EXPERIMENTS)[keyof typeof CURRENT_EXPERIMENTS]
  | string;

export type LayerName =
  | (typeof CURRENT_LAYERS)[keyof typeof CURRENT_LAYERS]
  | string;
